import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { createPortal } from "react-dom";
import PageRenderer     from "../../pageInside/PageBuilder/PageRenderer";
import Card from '../../pageInside/Card'
import { Row } from 'react-bootstrap';
import { getLakayUser } from "../../auth/apiProduct";
import ButtonPagination from "../../pageInside/ButtonPagination";
import { laguangeElakay, getElakayLanguageContext } from "../../pageInside/dataElakay";
import { getPublicIdentifier } from "../../../utils/publicIdentifier";
import SliderPun135 from "../../slider/swiperPub1500x400";
import ShopHeroSlider, { heroFromPub } from "../../dynamicSwipers/ShopHeroSlider";
import CategoryPub from "./categoryPub";
import { isAuthenticated, userPub, addFollowUserShop } from "../../auth";
import { prices } from "../../pageInside/fixedPrices";
import HeaderShopSeller from "../../Layout/headerShopSeller";
import { isShopOwner } from "../../Layout/shopManagementNavigation";
import elakayEmptyBox from "../../Layout/icon/elakayEmptyBox.png";
import { getMyShops, setShopDefault } from "../../auth/stripe";
import {
  getPageBuilderById,
  savePageBuilder,
  getMyPageBuilders,
  deletePageBuilder,
  verifyFamilyPageBuilderAccess,
  familyCopyPageBuilder,
} from "../../auth/apiPageBuilder";
import { Family } from "../../pageInside/Rolle";
import { SHOP_TEMPLATES } from "../../pageInside/PageBuilder/ShopBoutiqueTemplates";
// import SideDra from "../../../components/SIdeDrawer/sideDra+";

import SwiperCategoriesMatrix from "../../slider/swiperUserProd/swiperCategoriesMatrix.jsx"
import SwiperPubCategoryProdMatrix from "../../slider/swiperUserProd/swiperPubCategoryProdMatrix.jsx"
import ProductGridShop from "../../pageInside/ProductGridShop.jsx";
import { elakayAutoText } from "../../pageInside/dataElakay";
import { getProductGridLimit } from "../../../utils/paginationSettings";
import ShopSwitcher from "../../shops/ShopSwitcher";
import CreateShopButton from "../../shops/CreateShopButton";
import { separateLakayWord } from "../../../utils/lakayShopName";
import "./ShopPicker.css";
import { withBoutiqueAssociation } from "./pageBoutiqueAssociation";
import ShopProductDisplaySettings from "../../shops/ShopProductDisplaySettings";
import { isSellerProductDisplayAllowed, resolveShopProductDisplayMode, useViewportDevice } from "../../shops/productDisplay";
import { mergeUniqueById } from "../../../utils/infiniteScrollSettings";

const PageBuilder = React.lazy(() => import("../../pageInside/PageBuilder/PageBuilder"));
const PageBuilderHelp = React.lazy(() => import("../../pageInside/PageBuilder/PageBuilderHelp"));

 
let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["shopUser"]?.[key] || fallback;

const isPurchasedShopPage = (page) =>
  page?.pageMode === "store" && Boolean(page?.sourceModel || page?.purchasedFrom);

function processData(data) {
    // Obtenez une liste plate avec tous les noms
    const allNames = data.flatMap(item => item.name);
    const nameCounts = allNames.reduce((acc, name) => {
        acc[name] = (acc[name] || 0) + 1;
        return acc;
    }, {});

    return data?.map(item => {
        // Filtrer les noms qui ne sont pas communs à tous les tableaux
        const filteredNames = item.name.filter(name => nameCounts[name] < data?.length);

        // Trouver un groupe de genre (comme "Men", "Women", "Boys")
        const genderGroup = filteredNames.find(name =>
            ["Men", "Women", "Boys", 'Girls', 'Babies'].includes(name.trim())
        );

        // Construire "cateryName" avec l'élément principal et le groupe de genre
        const categoryNameParts = [genderGroup, item.name[0]].filter(Boolean);
        const categoryName = categoryNameParts.join(" ").trim();

        return {
            ...item,
            cateryName: categoryName
        };
    });
}
const COLORS1 = [
    "GhostWhite",        // très pâle
    "Ivory",             // très pâle
    "MintCream",         // très pâle
    "Silver",            // neutre clair
    "White",             // neutre total
    "LightGray",         // clair
    "Gainsboro",         // clair
    "LightSlateGray",    // doux
    "LightSteelBlue",    // pastel bleu
    "AliceBlue",         // bleu très pâle
    "AntiqueWhite",      // beige doux
    "Azure",             // bleu très clair
    "Beige",             // beige doux
    "Bisque",            // pêche pâle
    "BlanchedAlmond",    // beige amande
    "Cornsilk"           // jaune très pâle
  ];
  const COLORS = [
    "Gray",              // 1
      "GhostWhite",        // 2
      "Ivory",             // 3
      "MintCream",         // 4
      "Silver",            // 5
    //   "White",             // 6
      "LightGray",         // 7
      "Gainsboro",         // 8
      "DimGray",           // 9
      "SlateGray",         // 10
      "DarkGray",          // 11
      "LightSlateGray",    // 12
      "LightSteelBlue",    // 13
      "AliceBlue",         // 14
      "AntiqueWhite",      // 15
      "Azure",             // 16
      "Beige",             // 17
      "Bisque",            // 18
      "BlanchedAlmond",    // 19
      "Blue",              // 20
      "BlueViolet",        // 21
      "Brown",             // 22
      "BurlyWood",         // 23
      "CadetBlue",         // 24
      "Chartreuse",        // 25
      "Chocolate",         // 26
      "Coral",             // 27
      "CornflowerBlue",    // 28
      "Cornsilk",          // 29
      "Crimson",           // 30
      "Cyan",              // 31
      "DarkBlue",          // 32
      "DarkCyan",          // 33
      "DarkGoldenRod",     // 34
      "DarkGreen",         // 35
      "DarkKhaki",         // 36
      "DarkMagenta",       // 37
      "DarkOliveGreen",    // 38
      "DarkOrange",        // 39
      "DarkOrchid",        // 40
      "DarkRed",           // 41
      "DarkSalmon",        // 42
      "DarkSeaGreen",      // 43
      "DarkSlateBlue",     // 44
      "DarkSlateGray",     // 45
      "DarkTurquoise",     // 46
      "DarkViolet",        // 47
      "DeepPink",          // 48
      "DeepSkyBlue",       // 49
      "DodgerBlue"         // 50
    ];
    
      const galleryImages = [
    {
      id: 1,
      url: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800&h=1000&fit=crop',
      get alt() { return elakayAutoText("h_d38e66df832110", "Woman in white crop top"); },
      caption: __elakayText("t001", "Summer Collection")
    },
    {
      id: 2,
      url: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&h=1000&fit=crop',
      get alt() { return elakayAutoText("h_36211cdcad1411", "Woman in blue polo"); },
      caption: __elakayText("t002", "Sport Lifestyle")
    },
    {
      id: 3,
      url: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&h=1000&fit=crop',
      get alt() { return elakayAutoText("h_00b86c24e85aec", "Child in white polo"); },
      caption: __elakayText("t003", "Kids Collection")
    },
    {
      id: 4,
      url: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=800&h=1000&fit=crop',
      get alt() { return elakayAutoText("h_def57178772147", "Fashion model"); },
      caption: __elakayText("t004", "Premium Line")
    },
    {
      id: 5,
      url: 'https://images.unsplash.com/photo-1581803118522-7b72a50f7e9f?w=800&h=1000&fit=crop',
      get alt() { return elakayAutoText("h_2364ea8dd57f6a", "Casual wear"); },
      caption: __elakayText("t005", "Everyday Style")
    }
  ];

    const getRandomColor = () =>
      COLORS[Math.floor(Math.random() * COLORS?.length)];

const ShopUserView = props => {
    const {
        token = undefined,
        setLoading: reportLoading,
        infoSource,
        promoMaker= false,
        outOffPage= true,
        showFilter = true,
        myShop = false,
        showShopSwitcher = true,
        userID,
        ci,
        setFilterShop,
        myFilters ,
        prices,
        setCalFilShop,
        btnShopPromo,
        setRefShopName,
        refShopName,
        setInfoHeaderShop,
        // Multi-shop: which of the owner's shops to show (visitor URL ?shop=,
        // or the shop the owner is managing). Omitted = the original shop.
        shopId = null
            } = props
            
    const [productsByArrival, setProductsByArrival] = useState([]);
    const [shopLoadError, setShopLoadError] = useState("");
    // Page size — admin-configurable via AnimationSettings → General →
    // "Pagination & Limites" (productGrids.productGridShop.limit). Falls
    // back to 12 exactly as before when unset.
    const limit = getProductGridLimit(infoSource?.allSettings, 'productGridShop', 12);
    const [skip, setSkip] = useState(0);
    const [size, setSize] = useState(0);
    const [siseProduct, setSiseProduct] = useState(0);
    const [getUserPub, setUserPub] = useState([]);
    const [pubCategoryProd, setPubCategoryProd] = useState([])
    const [nbrArr, setNbrArr] = useState(3)
    const [getCategoriesUser, setCategoriesUser] = useState([]);
    const [getOwner, setOwner] = useState([]);
    // Multi-shop: the shop shown (identity from the server, even with 0 products).
    const [shopInfo, setShopInfo] = useState(null);
    // My Shop owner: unsaved product display + "Preview as" device.
    const [displayDraft, setDisplayDraft] = useState(null);
    const [displayPreviewDevice, setDisplayPreviewDevice] = useState(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const [booFollow, setBooFollow] = useState(true);
    const [unFollow, setUnFollow] = useState(true);
    const [getCi, setCi] = useState(ci? ci: null);
    const [search, setSearch] = useState('')
    const [prodCat, setProdcat] = useState('All Products')
    const [shopLoading, setShopLoading] = useState(true);
    // The view's own loading (product grid). The page-level `setLoading` is
    // only ever CLEARED from here: a parent Layout shows its spinner INSTEAD
    // of its children, so reporting `true` unmounted this view, whose cleanup
    // then discarded the in-flight response -- the page stayed on
    // "Loading..." forever.
    const setLoading = (value) => { setShopLoading(value); if (!value) reportLoading?.(false); };
    const requestVersion = useRef(0);
    const presentationVersion = useRef(0);
    const scopedRequest = (...args) => {
      const version = ++requestVersion.current;
      setLoading(true);
      return { then: (success) => ({ catch: (failure) => getLakayUser(...args)
        .then((data) => { if (version === requestVersion.current) success(data); })
        .catch((error) => { if (version === requestVersion.current) failure(error); })
        .finally(() => { if (version === requestVersion.current) setLoading(false); }) }) };
    };
    useEffect(() => { if (infoSource.getShopFollow) unFollowShop(infoSource.getShopFollow); }, [shopInfo, infoSource.getShopFollow]);
    const divCatProduct = useRef(null);

    // ── Mode d'affichage : "boutique" | "builder" | "preview"
    const [pageShop, setPageShop] = useState("boutique");
    const builderDocRef = useRef(null);   // doc courant du PageBuilder
    const [previewKey, setPreviewKey] = useState(0);

    // ── Page personnalisée + boutique par défaut
    const [shopPageDoc, setShopPageDoc]     = useState(null);
    const [myShopDefault, setMyShopDefault] = useState(null);
    const [savedPageId, setSavedPageId]     = useState(null);
    const [savedPageData, setSavedPageData] = useState(null);

    // ── Groupes de boutiques (picker)
    const [myCreatedShops, setMyCreatedShops] = useState([]);
    const [myBoughtShops, setMyBoughtShops]   = useState([]);
    const [shopsLoaded, setShopsLoaded]       = useState(false);
    const [showShopPicker, setShowShopPicker] = useState(false);
    const [openGroups, setOpenGroups]         = useState({ created:true, bought:true, elakay:true });

    // ── Family : débloquer une boutique "Mes achats" sans droit d'affichage ──
    const [familySelectTargetId, setFamilySelectTargetId] = useState(null);
    const [familySelectPassword, setFamilySelectPassword] = useState("");
    const [familySelectError, setFamilySelectError]       = useState("");
    const [familySelectBusy, setFamilySelectBusy]         = useState(false);

    const handleSwitchPreview = () => {
      setPreviewKey(k => k + 1);
      setPageShop("preview");
    };
    const toggleBuilderPreview = () => {
      if (pageShop === "preview") {
        setPageShop("builder");
        return;
      }
      handleSwitchPreview();
    };

    // ── Charge les boutiques du seller + page par défaut
    const refreshMyShops = useCallback(async () => {
      const { token } = isAuthenticated() || {};
      if (!token) return;
      setShopsLoaded(false);
      try {
        const [shopsData, pagesData] = await Promise.all([
          getMyShops(token),
          getMyPageBuilders({ pageMode: "store" }, token),
        ]);
        if (shopsData.error) throw new Error(shopsData.error);

        setMyShopDefault(shopsData.myShopDefault || null);
        setMyBoughtShops(shopsData.myPurchased || []);
        const createdPages = (pagesData?.pages || shopsData?.myCreated || [])
          .filter((page) => !isPurchasedShopPage(page));
        setMyCreatedShops(createdPages);
        setShopsLoaded(true);
      } catch (error) {
        console.error("[refreshMyShops]", error);
      }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
      if (!myShop) return;
      refreshMyShops();
    }, [myShop]); // eslint-disable-line react-hooks/exhaustive-deps

    // For visitors (myShop=false): sync owner's myShopDefault + pre-populated shopDefault doc
    useEffect(() => {
      if (!myShop) {
        setMyShopDefault(getOwner?.myShopDefault || null);
        // shopDefault is already joined server-side via $lookup on pagebuilders
        if (getOwner?.shopDefault?.doc || getOwner?.shopDefault?.pages) {
          setShopPageDoc(getOwner.shopDefault);
        } else {
          setShopPageDoc(null);
        }
      }
    }, [myShop, getOwner?.myShopDefault, getOwner?.shopDefault]);

    useEffect(() => {
      const defaultId = myShopDefault;
      if (!defaultId) { setShopPageDoc(null); return; }
      const localTemplate = SHOP_TEMPLATES.find((template) => template._id === String(defaultId));
      if (localTemplate) { setShopPageDoc(null); return; }
      // Owners (myShop=true): shopDefault is not in getOwner, fetch via API
      if (!myShop) return; // visitors: already handled by the effect above
      const { token } = isAuthenticated() || {};
      let cancelled = false;
      getPageBuilderById(String(defaultId), token || undefined)
        .then((data) => {
          if (!cancelled && (data?.doc || data?.pages)) setShopPageDoc(data);
        })
        .catch(() => {});
      return () => { cancelled = true; };
    }, [myShopDefault, myShop]);

    const handleSetDefault = async (pageId, familyPassword = "") => {
      const { token } = isAuthenticated() || {};
      if (!token) return { success: false, error: elakayAutoText("h_c783a01cb9b954", "Connexion requise.") };
      const result = await setShopDefault(token, pageId, familyPassword);
      if (result.success) {
        setMyShopDefault(result.myShopDefault ?? null);
        setShopPageDoc(null);
      }
      return result;
    };

    // ── Family : débloquer + définir une boutique "Mes achats" sans droit
    // d'affichage acheté. Mot de passe re-vérifié côté serveur à chaque appel.
    const openFamilySelectPrompt = (id) => {
      setFamilySelectTargetId(id);
      setFamilySelectPassword("");
      setFamilySelectError("");
    };
    const closeFamilySelectPrompt = () => {
      if (familySelectBusy) return;
      setFamilySelectTargetId(null);
      setFamilySelectPassword("");
      setFamilySelectError("");
    };
    const submitFamilySelect = async (event) => {
      event?.preventDefault?.();
      if (!familySelectTargetId) return;
      if (!familySelectPassword.trim()) {
        setFamilySelectError(elakayAutoText("h_a3d97c1e0b8f52", "Entrez le mot de passe du compte Développeur."));
        return;
      }
      setFamilySelectBusy(true);
      setFamilySelectError("");
      try {
        const result = await handleSetDefault(familySelectTargetId, familySelectPassword);
        if (result?.success) {
          setShowShopPicker(false);
          setFamilySelectTargetId(null);
          setFamilySelectPassword("");
        } else {
          setFamilySelectError(result?.error || elakayAutoText("h_6e0f8a4d31c7b9", "Validation Développeur impossible."));
        }
      } finally {
        setFamilySelectBusy(false);
      }
    };

    const handleSelectElakayTemplate = async (templateId) => {
      const tpl = SHOP_TEMPLATES.find(t => t._id === templateId);
      if (!tpl) return;
      const result = await handleSetDefault(tpl._id);
      if (result?.success) setShowShopPicker(false);
    };

    const toggleGroup = (g) => setOpenGroups(prev => ({ ...prev, [g]: !prev[g] }));
    const getItemId    = (item) => {
      if (item.templateId) return String(item.templateId);
      // For purchase records (myShop), pageId is a string = the page builder doc ID
      if (item.pageId && typeof item.pageId === 'string') return item.pageId;
      return String(item._id || item.pageId?._id || item.pageId || "");
    };
    const getItemTitle = (item) => {
      const id = getItemId(item);
      const template = SHOP_TEMPLATES.find((entry) => entry._id === id || entry.key === id);
      return template?.label || item.title || item.pageId?.title || `Boutique …${id.slice(-4)}`;
    };

    const shopPickerMenu = () => {
      const groups = [
        { key:"created",  label:elakayAutoText("h_c98bded240203f", "Mes créations"), icon:"✏️", items:myCreatedShops, canSet:() => true },
        {
          key:"bought",
          label:elakayAutoText("h_1fe4e218494c21", "Mes achats"),
          icon:"🛒",
          items:myBoughtShops,
          canSet:(item) => Boolean(
            item?.displayRight ||
            item?.purchaseRights?.displayRight ||
            item?.pageId?.displayRight ||
            item?.sourceModel ||
            item?.purchasedFrom ||
            item?.pageId?.sourceModel ||
            item?.pageId?.purchasedFrom
          ),
        },
      ];
      const elakayShopPicker = infoSource?.allSettings?.shopPicker;
      const elakayShopsExpiresAt = new Date(elakayShopPicker?.elakayShopsExpiresAt || 0).getTime();
      const showElakayShops =
        elakayShopPicker?.showElakayShops === true &&
        Number.isFinite(elakayShopsExpiresAt) &&
        elakayShopsExpiresAt > Date.now();
      const activeId = myShopDefault ? String(myShopDefault) : null;
      const allPickerItems = [...myCreatedShops, ...myBoughtShops];
      const activeItem  = activeId ? allPickerItems.find(it => getItemId(it) === activeId) : null;
      const activeTemplate = activeId ? SHOP_TEMPLATES.find((tpl) => tpl._id === activeId) : null;
      const activeTitle = activeTemplate?.label || (activeItem ? getItemTitle(activeItem) : activeId ? `Boutique …${activeId.slice(-4)}` : null);

      return (
        <div
          className="shop-picker-backdrop"
          style={{ position:"fixed", inset:0, zIndex:3000, background:"rgba(15,10,40,0.5)", display:"flex", justifyContent:"flex-end" }}
          onClick={() => setShowShopPicker(false)}
        >
          <div
            className="shop-picker-panel"
            role="dialog"
            aria-modal="true"
            aria-label={elakayAutoText("h_449d130c916e1f", "Choisir une boutique")}
            style={{ width:"340px", height:"100%", background:"#fff", overflow:"auto", display:"flex", flexDirection:"column", boxShadow:"-4px 0 24px rgba(0,0,0,0.18)" }}
            onClick={e => e.stopPropagation()}
          >
            {/* En-tête */}
            <div className="shop-picker-header" style={{ padding:"18px 20px 14px", borderBottom:"1px solid #ede9fd", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, background:"#fff", zIndex:1 }}>
              <div className="shop-picker-heading"><span className="shop-picker-heading-icon">🏪</span><div><strong>{elakayAutoText("h_449d130c916e1f", "Choisir une boutique")}</strong><small>{elakayAutoText("h_d0e650445c1f18", "Sélectionnez la boutique affichée à vos clients")}</small></div></div>
              <button className="shop-picker-close" aria-label={elakayAutoText("h_944918ea5ab14c", "Fermer")} onClick={() => setShowShopPicker(false)} style={{ background:"none", border:"none", cursor:"pointer", fontSize:"18px", color:"#9b93b8", lineHeight:1 }}>✕</button>
            </div>

            {/* Bannière boutique active + bouton Supprimer */}
            {activeId && (
              <div className="shop-picker-active" style={{ padding:"10px 16px", background:"#fffbeb", borderBottom:"1px solid #fde68a", display:"flex", alignItems:"center", gap:"10px" }}>
                <span style={{ fontSize:"16px", flexShrink:0 }}>⭐</span>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:"10px", fontWeight:600, color:"#92400e", textTransform:"uppercase", letterSpacing:"0.05em" }}>{elakayAutoText("h_e513a5a571e23b", "Boutique active")}</div>
                  <div style={{ fontSize:"12px", fontWeight:700, color:"#1a1a2e", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{activeTitle}</div>
                </div>
                <button
                  onClick={() => handleSetDefault(null)}
                  style={{ flexShrink:0, padding:"5px 10px", fontSize:"11px", fontWeight:700, color:"#dc2626", background:"#fef2f2", border:"1px solid #fca5a5", borderRadius:"6px", cursor:"pointer", whiteSpace:"nowrap" }}
                >{elakayAutoText("h_1acfc1c7d76131", "Supprimer")}</button>
              </div>
            )}

            {!shopsLoaded && (
              <div style={{ padding:"24px 16px", fontSize:"12px", color:"#9ca3af", textAlign:"center" }}>{elakayAutoText("h_613e6d92675967", "Chargement de vos boutiques…")}</div>
            )}

            {/* Visibilité administrée dans AnimationSettings > Général. */}
            {showElakayShops && (
              <div style={{ padding:"12px 16px", borderBottom:"1px solid #f3f4f6" }}>
                <div
                  onClick={() => handleSetDefault(null)}
                  style={{ display:"flex", alignItems:"center", gap:"12px", padding:"10px 14px", borderRadius:"10px", cursor:"pointer", background:!activeId?"#f0fdf4":"#f9fafb", border:!activeId?"1.5px solid #86efac":"1px solid #e5e7eb" }}
                >
                  <span style={{ fontSize:"20px" }}>🏬</span>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:"13px", fontWeight:700, color:"#1a1a2e" }}>{elakayAutoText("h_25392ad3025b1d", "Boutique elakay par défaut")}</div>
                    <div style={{ fontSize:"11px", color:"#6b7280" }}>{elakayAutoText("h_c1071415439be2", "Vue produits standard")}</div>
                  </div>
                  {!activeId && <span style={{ fontSize:"14px", color:"#16a34a", fontWeight:800 }}>✓</span>}
                </div>
              </div>
            )}

            {/* Groupes */}
            {shopsLoaded && groups.map(({ key, label, icon, items, canSet }) => (
              <section className="shop-picker-group" key={key} style={{ borderBottom:"1px solid #f3f4f6" }}>
                {/* Titre du groupe (clic pour ouvrir/fermer) */}
                <button type="button" className="shop-picker-group-toggle"
                  onClick={() => toggleGroup(key)}
                  style={{ padding:"11px 16px", display:"flex", alignItems:"center", gap:"8px", cursor:"pointer", background:"#fafafa", userSelect:"none" }}
                >
                  <span style={{ fontSize:"15px" }}>{icon}</span>
                  <span style={{ flex:1, fontSize:"13px", fontWeight:700, color:"#374151" }}>{label}</span>
                  <span style={{ fontSize:"12px", color:"#9ca3af", marginRight:"4px" }}>({items.length})</span>
                  <span style={{ fontSize:"10px", color:"#9ca3af" }}>{openGroups[key] ? "▲" : "▼"}</span>
                </button>

                {openGroups[key] && (
                  <div className="shop-picker-list" style={{ padding:"6px 12px 10px", display:"flex", flexDirection:"column", gap:"5px" }}>
                    {items.length === 0 ? (
                      <div style={{ padding:"10px 8px", fontSize:"12px", color:"#9ca3af", textAlign:"center" }}>{elakayAutoText("h_d3cd423b4457df", "Aucune boutique")}</div>
                    ) : items.map((item) => {
                      const id      = getItemId(item);
                      const title   = getItemTitle(item);
                      const isActive = id && activeId === id;
                      const canSetItem = typeof canSet === "function" ? canSet(item) : Boolean(canSet);
                      return (
                        <div className={`shop-picker-card${isActive ? " is-active" : ""}`} key={id} style={{ display:"flex", alignItems:"center", gap:"8px", padding:"8px 10px", borderRadius:"8px", background:isActive?"#f0fdf4":"#fff", border:isActive?"1.5px solid #86efac":"1px solid #e5e7eb" }}>
                          <span style={{ flex:1, fontSize:"13px", color:"#1a1a2e", fontWeight:isActive?700:400, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }} title={title}>
                            {title}
                          </span>
                          {isActive ? (
                            <span style={{ fontSize:"14px", color:"#16a34a", fontWeight:800, flexShrink:0 }}>✓</span>
                          ) : canSetItem ? (
                            <button
                              onClick={() => handleSetDefault(id)}
                              style={{ padding:"4px 10px", fontSize:"11px", fontWeight:700, color:"#6d28d9", background:"#f5f3ff", border:"1px solid #ddd6fe", borderRadius:"6px", cursor:"pointer", whiteSpace:"nowrap", flexShrink:0 }}
                            >{elakayAutoText("h_85e64e913a1546", "Définir")}</button>
                          ) : Family(infoSource?.userInfo?.email) ? (
                            <button
                              onClick={() => openFamilySelectPrompt(id)}
                              title={elakayAutoText("h_1f6c8b3e94ad70", "Débloquer (Développeur) — droit d'affichage non acheté")}
                              style={{ padding:"4px 10px", fontSize:"11px", fontWeight:700, color:"#b45309", background:"#fffbeb", border:"1px solid #f59e0b", borderRadius:"6px", cursor:"pointer", whiteSpace:"nowrap", flexShrink:0 }}
                            >🔓{elakayAutoText("h_9c2a5f708e1db4", "Developer")}</button>
                          ) : (
                            <button disabled title={elakayAutoText("h_2eeff7de69c14a", "Le droit d'affichage n'a pas été acheté")} style={{ padding:"4px 10px", fontSize:"11px", fontWeight:600, color:"#9ca3af", background:"#f9fafb", border:"1px solid #e5e7eb", borderRadius:"6px", cursor:"not-allowed", whiteSpace:"nowrap", flexShrink:0 }}>{elakayAutoText("h_983e43cf7d363c", "HTML seul")}</button>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </section>
            ))}

            {showElakayShops && (
              <div style={{ borderBottom:"1px solid #f3f4f6" }}>
                <div
                  onClick={() => toggleGroup("elakay")}
                  style={{ padding:"11px 16px", display:"flex", alignItems:"center", gap:"8px", cursor:"pointer", background:"#fafafa", userSelect:"none" }}
                >
                  <span style={{ fontSize:"15px" }}>🏪</span>
                  <span style={{ flex:1, fontSize:"13px", fontWeight:700, color:"#374151" }}>{elakayAutoText("h_c7764b8a85ed99", "Boutiques elakay")}</span>
                  <span style={{ fontSize:"12px", color:"#9ca3af", marginRight:"4px" }}>({SHOP_TEMPLATES.length})</span>
                  <span style={{ fontSize:"10px", color:"#9ca3af" }}>{openGroups.elakay ? "▲" : "▼"}</span>
                </div>
                {openGroups.elakay && (
                  <div style={{ padding:"6px 12px 10px", display:"flex", flexDirection:"column", gap:"5px" }}>
                    {SHOP_TEMPLATES.map((tpl) => {
                      const isActive = activeId === tpl._id;
                      return (
                        <div
                          key={tpl._id}
                          style={{ display:"flex", alignItems:"center", gap:"8px", padding:"10px", borderRadius:"8px", background:isActive?"#f0fdf4":"#fff", border:isActive?"1.5px solid #86efac":"1px solid #e5e7eb", cursor:"pointer" }}
                          onClick={() => handleSelectElakayTemplate(tpl._id)}
                        >
                          <div style={{ display:"flex", gap:"4px", flexShrink:0 }}>
                            {tpl.palette?.map((c, i) => (
                              <span key={i} style={{ width:"10px", height:"10px", borderRadius:"50%", background:c, border:"1px solid rgba(0,0,0,0.1)", display:"inline-block" }} />
                            ))}
                          </div>
                          <div style={{ flex:1, minWidth:0 }}>
                            <div style={{ fontSize:"13px", fontWeight:isActive?700:500, color:"#1a1a2e", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{tpl.label}</div>
                            <div style={{ fontSize:"11px", color:"#6b7280", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{tpl.description}</div>
                          </div>
                          {isActive
                            ? <span style={{ fontSize:"14px", color:"#16a34a", fontWeight:800, flexShrink:0 }}>✓</span>
                            : <button
                                onClick={(e) => { e.stopPropagation(); handleSelectElakayTemplate(tpl._id); }}
                                style={{ padding:"4px 10px", fontSize:"11px", fontWeight:700, color:"#6d28d9", background:"#f5f3ff", border:"1px solid #ddd6fe", borderRadius:"6px", cursor:"pointer", whiteSpace:"nowrap", flexShrink:0 }}
                              >{elakayAutoText("h_b030d590c21c95", "Choisir")}</button>
                          }
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

          </div>

          {/* ── Débloquer une boutique achetée sans droit d'affichage (Family) ── */}
          {familySelectTargetId && (
            <div
              onClick={(e) => { if (e.target === e.currentTarget) closeFamilySelectPrompt(); }}
              style={{ position:"fixed", inset:0, zIndex:3100, background:"rgba(15,10,40,0.55)", display:"flex", alignItems:"center", justifyContent:"center", padding:"18px" }}
            >
              <form onSubmit={submitFamilySelect} style={{ width:"100%", maxWidth:"360px", background:"#fff", borderRadius:"16px", overflow:"hidden", boxShadow:"0 20px 60px rgba(15,10,40,0.3)" }}>
                <div style={{ padding:"14px 18px", background:"linear-gradient(135deg,#92400e,#d97706)", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                  <span style={{ color:"#fff", fontSize:"14px", fontWeight:800 }}>{elakayAutoText("h_2a5d719cf3b064", "Validation Développeur requise")}</span>
                  <button type="button" onClick={closeFamilySelectPrompt} disabled={familySelectBusy} style={{ border:"none", background:"transparent", color:"#fff", fontSize:"20px", lineHeight:1, cursor:familySelectBusy?"not-allowed":"pointer" }}>×</button>
                </div>
                <div style={{ padding:"18px", display:"flex", flexDirection:"column", gap:"10px" }}>
                  <div style={{ padding:"9px 11px", borderRadius:"9px", background:"#fffbeb", border:"1px solid #fde68a", color:"#92400e", fontSize:"11px", lineHeight:1.5 }}>
                    {elakayAutoText("h_37b9e1cd6a8f42", "Définit cette boutique comme active sans avoir acheté le droit d'affichage.")}
                  </div>
                  <label style={{ display:"block" }}>
                    <span style={{ display:"block", fontSize:"10px", fontWeight:800, color:"#7a73a0", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:"5px" }}>{elakayAutoText("h_d6d1d7e5ff8b0f", "Mot de passe du compte Développeur")}</span>
                    <input
                      type="password"
                      value={familySelectPassword}
                      onChange={(e) => setFamilySelectPassword(e.target.value)}
                      autoFocus
                      style={{ width:"100%", padding:"9px 11px", fontSize:"13px", border:"1px solid #e4dcfb", borderRadius:"8px", outline:"none", boxSizing:"border-box" }}
                    />
                  </label>
                  {familySelectError && (
                    <div style={{ fontSize:"11px", color:"#e11d48", fontWeight:600 }}>{familySelectError}</div>
                  )}
                  <button type="submit" disabled={familySelectBusy}
                    style={{ padding:"9px 14px", fontSize:"12px", fontWeight:700, color:"#fff", border:"none", borderRadius:"8px",
                      background: familySelectBusy ? "#9ca3af" : "linear-gradient(135deg,#d97706,#b45309)", cursor: familySelectBusy ? "not-allowed" : "pointer" }}>
                    {familySelectBusy ? elakayAutoText("h_f8bf3646407b3b", "En cours…") : elakayAutoText("h_4c8d2b91a06e35", "Débloquer (Développeur)")}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      );
    };

    const handleSavePage = async (payload) => {
      const { token } = isAuthenticated() || {};
      if (!token) return;
      // Family peut modifier en place sa propre boutique en lecture seule
      // après re-confirmation du mot de passe (payload.familyPassword) —
      // le serveur re-vérifie rôle + mot de passe indépendamment à chaque
      // appel (voir updatePage), ce garde côté client n'est là que pour les
      // sauvegardes normales, non déverrouillées.
      const hasFamilyOverride = Boolean(payload?.familyPassword);
      if (!hasFamilyOverride) {
        if (
          savedPageData?.shopSource &&
          savedPageData.shopSource !== "created"
        ) {
          throw new Error("Lecture seule : seules les boutiques de la liste Créées peuvent être modifiées.");
        }
        if (isPurchasedShopPage(savedPageData)) {
          throw new Error("Lecture seule : une boutique achetée ne peut pas être modifiée.");
        }
      }
      // Phase A multiboutique: PageBuilder already exposes a Mixed settings
      // bag, so record the exact commercial boutique without a schema change
      // or second source of truth. Product.boutiqueId[] and User.boutiques[]
      // remain authoritative; this is only the page association.
      const activeBoutiqueId = shopInfo?._id || shopId || null;
      const data = await savePageBuilder(withBoutiqueAssociation(payload, activeBoutiqueId), savedPageId, token);
      if (data?._id) {
        setSavedPageId(data._id);
        setSavedPageData(data);
        refreshMyShops();
      }
      return data;
    };

    const handleLoadBuilderPage = useCallback((doc, pageId, pageData = null) => {
      builderDocRef.current = doc;
      setSavedPageId(pageId || null);
      setSavedPageData(pageData);
    }, []);

    // Suppression d'une page PageBuilder possédée par l'utilisateur (créée ou
    // achetée — aucune restriction serveur au-delà de la propriété, voir
    // deletePage côté backend). PageBuilder n'affiche ce bouton pour une
    // boutique achetée qu'après re-confirmation Family, en garde-fou client.
    const handleDeleteSavedPage = useCallback(async (id) => {
      const { token } = isAuthenticated() || {};
      if (!token) return;
      await deletePageBuilder(id, token);
      if (savedPageId && String(savedPageId) === String(id)) {
        builderDocRef.current = null;
        setSavedPageId(null);
        setSavedPageData(null);
      }
      refreshMyShops();
    }, [savedPageId, refreshMyShops]);

    const handleFamilyUnlockPage = useCallback(async (sourcePage, password) => {
      const { token } = isAuthenticated() || {};
      if (!token) throw new Error("Connexion requise.");

      if (sourcePage?._id) {
        const copy = await familyCopyPageBuilder(sourcePage._id, password, token);
        setSavedPageId(copy._id);
        setSavedPageData({ ...copy, shopSource: "created" });
        builderDocRef.current = copy.doc;
        refreshMyShops();
        return { ...copy, shopSource: "created" };
      }

      // Validation seule (sourcePage=null) : débloque l'édition EN PLACE de la
      // page actuellement ouverte dans le Builder — on ne touche à aucun état,
      // PageBuilder rejoue ce mot de passe sur ses prochains appels onSave.
      await verifyFamilyPageBuilderAccess(password, token);
      return { verified: true };
    }, [refreshMyShops]);

    // ── Données live du shop pour PageBuilder / PageRenderer
    const shopLiveDatasets = useMemo(() => {
      const owner = !Array.isArray(getOwner) && getOwner?.shopName ? getOwner : null;
      if (!owner) return null;
      const sName = Array.isArray(owner.shopName) ? owner.shopName[0] : (owner.shopName || "Boutique");
      return {
        store: {
          label: `${sName} — données réelles`,
          pageMode: "store",
          data: {
            shopId: shopInfo?._id || shopId || null,
            shop: myShop && displayDraft && shopInfo ? { ...shopInfo, productDisplay: displayDraft } : shopInfo,
            productDisplayPreviewDevice: myShop ? displayPreviewDevice : null,
            products:             productsByArrival || [],
            owner,
            categories:           getCategoriesUser || { shopName: sName, categories: [] },
            pubCategoryProdMatrix: pubCategoryProd  || { shopName: sName, products: []  },
            sliderShop:           getUserPub?.sliderShop || [],
            // Main Shop Slider Source (gallery | Elakay Swiper).
            sliderShopHero:       heroFromPub(getUserPub),
            filters:              [],
            siseProduct:          siseProduct || 0,
            siseProductAll:       siseProduct || 0,
            shopActive:           true,
            links: {
              homePage: "/",
              shopPage: `/lakay-ShopSeller/${owner?.publicId || owner?._id || userID}${shopInfo?._id || shopId ? `?shop=${shopInfo?._id || shopId}` : ""}`,
              aboutPage: `/lakay-ShopSeller/${owner?.publicId || owner?._id || userID}/about${shopInfo?._id || shopId ? `?shop=${shopInfo?._id || shopId}` : ""}`,
              productDetail: "/product/preview",
              myShop: "/myShop",
              cartPage: "/cart",
              checkoutPage: "/cart",
              signinPage: "/signin",
            },
          },
          isLive: true,
        },
      };
    }, [getOwner, productsByArrival, getCategoriesUser, pubCategoryProd, siseProduct, getUserPub, userID, shopId, shopInfo, myShop, displayDraft, displayPreviewDevice]);

    const previewDataByMode = shopLiveDatasets?.store?.data ?? null;
    const selectedShopTemplate = useMemo(
      () => SHOP_TEMPLATES.find((template) => template._id === String(myShopDefault || "")) || null,
      [myShopDefault]
    );
    const selectedShopDoc = useMemo(() => {
      if (selectedShopTemplate) return selectedShopTemplate.make();
      const pageDoc = shopPageDoc?.doc || shopPageDoc;
      return Array.isArray(pageDoc?.pages) ? pageDoc : null;
    }, [selectedShopTemplate, shopPageDoc]);

    const scrollToParagraph = (ref) => {
         if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }
      };


      const loadindSearCh = (s) => { setSearch(s); if (s?.length > 2) scrollToParagraph(divCatProduct); };

const onFilterShop = ()=>{
    setSearch('')
    setFilterShop(true)
    scrollToParagraph(divCatProduct)
}

    const findToFollowU = (a, ub, uc)=>{
        // userID (param d'URL) peut etre un publicId (ex: "u-8Kx42Z") : on
        // compare au vrai _id du owner deja resolu par getLakayUser (getOwner),
        // et on ne retombe sur userID que tant que getOwner n'est pas charge.
        const ownerRealId = String(getOwner?._id || userID);
        let boo
        if(ub &&  ownerRealId === String(ub._id)){
            boo = false
        }else if(ownerRealId === String(uc)){
            boo=  false
        }else{

            boo = true
        }
        setBooFollow(boo)
     }


     const unFollowShop =(a)=>{
        const ownerRealId = String(getOwner?._id || userID);
        let b =  !a.some(ob => ob && String(ob.shopId || "") === String(shopInfo?._id || shopId || ""))
        setUnFollow(b)
     }

     const clickToFollowShop = async ()=>{
        const authToken = token || isAuthenticated()?.token;
        if (!authToken) {
            window.location.href = "/signin";
            return { success: false, error: "not-authenticated" };
        }
        const data = await addFollowUserShop(authToken, userID, shopInfo?._id || shopId, unFollow);
        if (!data || data.error) return data;
        unFollowShop(data.followShopUser || []);
        if (data.shopFollowerCount !== undefined) setShopInfo((shop) => shop && ({ ...shop, followers: data.shopFollowerCount }));
        if (typeof infoSource?.readUser === "function") {
            await Promise.resolve(infoSource.readUser(authToken, ["getShopFollow"])).catch(() => null);
        }
        return data;
     }


//  const reziArray = (a, n)=>{
//        let arr = a.slice(0, n)
//        setPubCategoryProd(arr)
//        setNbrArr(n)
//     }

    const resizeWidth = ()=>{
        setWindowWidth(window.innerWidth)
    }
const loadingUserPub =(uid)=>{
    const version = ++presentationVersion.current;
    setUserPub([]);
    userPub(uid, shopId).then(data => {
        if (version !== presentationVersion.current) return;
        if(!data){
        }else{
    setUserPub(data)
        }
    })
}

    const loadProductsByArrival = (search, myFilters) => {
       setShopLoadError("")
       userID &&  scopedRequest(userID, skip, limit, "createdAt", getCi, search, {filters : myFilters.filters, facet:["shopLakayUser", "shop_Owner", "shop_Filters", "shop_Products_Categories", "pubCategoryProd"]}, undefined, shopId).then(data => {
        if(!data || data.error || data.locationUnavailable){
                setProductsByArrival([])
                setSiseProduct(0)
                setSize(0)
                // Seller Strict Location: this shop does not sell to the
                // current destination (Target Location / address / approximate
                // IP) -- the server returned no shop data at all.
                setShopLoadError(data?.locationUnavailable
                    ? `${elakayAutoText("h_locctx_shop_unavailable", "This shop is not available in your selected location")}${data.location?.label ? ` (${data.location.label})` : ""}. ${elakayAutoText("h_locctx_change_location", "Change your location in the Filters panel to check another area.")}`
                    : (data?.error || elakayAutoText("h_myshop_customer_load_error", "Unable to load the customer shop view.")))
                setLoading(false)
            }else{
                setCi(null)
                setProductsByArrival(data.products || []);
                setCategoriesUser(data.categories || [])
                setPubCategoryProd(data.pubCategoryProdMatrix || [])
                setOwner(data?.owner || {})
                setShopInfo(data?.shop || null)

                setCalFilShop?.({owner: data?.owner, categoies: data.categories, filters: data.filters, prices})
             
                const ownerShopName = data?.shop?.name || data?.owner?.shopName;
                promoMaker && setRefShopName(Array.isArray(ownerShopName) ? "lakay " + ownerShopName[0] : "lakay " + (ownerShopName || ""))

                setSiseProduct(data.siseProduct || 0)
                setSize(data.size || 0);
                setSkip(0);
                setLoading(false)

               infoSource.userInfo && infoSource.userInfo._id && findToFollowU(infoSource.getShopFollow, infoSource.userAdmin, infoSource.userInfo._id) 
               infoSource.getShopFollow && unFollowShop(infoSource.getShopFollow)

                setInfoHeaderShop?.({setFilterShop, onFilterShop, loadindSearCh, search, shopName: Array.isArray(ownerShopName) ? ownerShopName[0] : ownerShopName, ownerId: data?.owner?._id})
                
            }
        }).catch(error => {
            setProductsByArrival([])
            setShopLoadError(error?.message || elakayAutoText("h_myshop_customer_load_error", "Unable to load the customer shop view."))
            setLoading(false)
        });
    };

const loadProductsByArrival_ = (getCi=  null,  n= 'All Products') => {
       userID &&  scopedRequest(userID, skip, limit, "createdAt", getCi, search, {filters : myFilters.filters, facet:["shopLakayUser", "shop_Filters"]}, undefined, shopId).then(data => {
        
            if(data.error){
                setLoading(false)
            }else{
                setProductsByArrival(data.products || []);
                setCalFilShop?.({owner: getOwner, categoies: getCategoriesUser, filters: data.filters, prices})
                setSiseProduct(data.siseProduct || 0)
                setSize(data.size || 0);
                setSkip(0);
                setLoading(false)

                infoSource.userInfo && infoSource.userInfo._id && findToFollowU(infoSource.getShopFollow, infoSource.userAdmin, infoSource.userInfo._id) 
               infoSource.getShopFollow && unFollowShop(infoSource.getShopFollow)


                setCi(getCi)
                setSearch('')
                setProdcat(n)
                scrollToParagraph(divCatProduct)
                
            }
        }).catch(error => {
            setLoading(false)
        });
    };

    const loadMore = () => {
        let toSkip = skip + limit;

        scrollToParagraph(divCatProduct);
        userID &&   scopedRequest(userID, toSkip, limit, "createdAt", getCi, search, {filters : myFilters.filters, facet:["shopLakayUser"]}, undefined, shopId).then(data => {
          
            setProductsByArrival(data.products)
            setSiseProduct(data.siseProduct)
            setSize(data.size);
            setSkip(toSkip);

        }).catch(error => {
        })
    };

    // ── Product display (Shop Product Grid / Infinite Scroll) ───────────
    // Owner draft + "Preview as" device only exist in My Shop; visitors get
    // the saved boutique choice (shop.productDisplay), gated by Developer.
    const viewportDevice = useViewportDevice();
    const displayDevice = (myShop && displayPreviewDevice) || viewportDevice;
    const shopDisplay = (myShop && displayDraft) || shopInfo?.productDisplay;
    const productDisplayMode = resolveShopProductDisplayMode({ allSettings: infoSource?.allSettings, shopDisplay, device: displayDevice });
    const productsRef = useRef(productsByArrival);
    productsRef.current = productsByArrival;
    const appendInFlight = useRef(false);
    const [appending, setAppending] = useState(false);
    // Next batch of the SAME list (skip = products shown), merged by _id.
    // A batch answered after a filter / category / search change is dropped
    // (requestVersion is bumped by every scopedRequest).
    const appendProducts = async () => {
        if (appendInFlight.current || !userID) return { ok: false, busy: true };
        appendInFlight.current = true;
        setAppending(true);
        const version = requestVersion.current;
        try {
            const data = await getLakayUser(userID, productsRef.current.length, limit, "createdAt", getCi, search, { filters: myFilters.filters, facet: ["shopLakayUser"] }, undefined, shopId);
            if (version !== requestVersion.current) return { ok: false, stale: true };
            if (!data || data.error) throw new Error(data?.error || "load-failed");
            const received = Array.isArray(data.products) ? data.products : [];
            setProductsByArrival((current) => mergeUniqueById(current, received));
            if (data.siseProduct !== undefined) setSiseProduct(data.siseProduct);
            return { ok: true, received: received.length };
        } catch (error) {
            return { ok: false, error: error?.message || "load-failed" };
        } finally {
            appendInFlight.current = false;
            setAppending(false);
        }
    };
    // Switching mode never keeps a list built for the other mode: back to
    // the first page (grid) / a list starting at product 1 (infinite).
    const previousDisplayMode = useRef(productDisplayMode);
    useEffect(() => {
        const previous = previousDisplayMode.current;
        previousDisplayMode.current = productDisplayMode;
        if (previous === productDisplayMode) return;
        if (productDisplayMode === "grid") {
            setProductsByArrival((current) => current.slice(0, limit));
            setSize((current) => Math.min(current, limit));
        } else if (skip !== 0) {
            requestVersion.current++;
            userID && scopedRequest(userID, 0, limit, "createdAt", getCi, search, { filters: myFilters.filters, facet: ["shopLakayUser"] }, undefined, shopId).then((data) => {
                if (!data || data.error) return;
                setProductsByArrival(data.products || []);
                setSiseProduct(data.siseProduct || 0);
                setSize(data.size || 0);
                setSkip(0);
            }).catch(() => {});
        }
    }, [productDisplayMode]); // eslint-disable-line react-hooks/exhaustive-deps

    const loadMore0 = () => {
        let toSkip = skip - limit;
        scrollToParagraph(divCatProduct);
        userID &&   scopedRequest(userID, toSkip, limit, "createdAt", getCi,  search,  {filters : myFilters.filters, facet:["shopLakayUser"]}, undefined, shopId).then(data => {

            setProductsByArrival(data.products);
            setSiseProduct(data.siseProduct);
            setSize(data.size);
            setSkip(toSkip);

        }).catch(error => {
        });
    };
 


    useEffect(() => {
        window.addEventListener('resize', resizeWidth)
        loadProductsByArrival(search, myFilters)
       loadingUserPub(userID)
        return () => { requestVersion.current++; presentationVersion.current++; window.removeEventListener('resize', resizeWidth); }
    }, [ myFilters, search, userID, shopId, limit]);


    // ── Style bouton de mode (header overlay) ──────────────────────────────
    const modeBtn = (active) => ({
      display: "flex", alignItems: "center", gap: "6px",
      padding: "8px 18px", fontSize: "13px", fontWeight: active ? 700 : 500,
      color: active ? "#6d28d9" : "#6b7280",
      background: active ? "#f5f3ff" : "#fff",
      border: `1px solid ${active ? "#c4b5fd" : "#e5e7eb"}`,
      borderRadius: "50px", cursor: "pointer", transition: "all 0.15s",
    });

    const shopDisplayName = separateLakayWord(shopInfo?.name
      ? shopInfo.name
      : getOwner && !Array.isArray(getOwner) && getOwner.shopName
        ? (Array.isArray(getOwner.shopName) ? getOwner.shopName[0] : getOwner.shopName)
        : (shopInfo?.name || "seller"));
    const shopPublicId = getPublicIdentifier(getOwner, userID);
    // The very first answer is still on its way (the owner is unknown): the
    // category and gallery swipers hold their height with placeholder slides.
    const firstShopLoad = shopLoading && Array.isArray(getOwner);
    const secondaryShopPath = shopInfo?._id ? `/lakay-ShopSeller/${shopPublicId}?shop=${shopInfo._id}` : undefined;
    const pageRendererDevice = windowWidth <= 480
      ? "mobile"
      : windowWidth <= 768
        ? "tablet"
        : "desktop";

    return (
    <>
      {/* ── Header boutique (mode normal) ────────────────────────────── */}
      {outOffPage && (
        <HeaderShopSeller
          infoSource={infoSource}
          userID={shopPublicId}
          shopPath={secondaryShopPath}
          titleExtra={myShop && showShopSwitcher ? (
            <span className="msh-header-slot">
              <ShopSwitcher type="seller" showCreate={false} />
              <CreateShopButton type="seller" />
            </span>
          ) : null}
          setFilterShop={setFilterShop}
          onFilterShop={onFilterShop}
          shopName={shopDisplayName}
          loadindSearCh={loadindSearCh}
          search={search}
          outOffPage={outOffPage}
          showFilter={showFilter}
          myShop={myShop}
          setPageShop={setPageShop}
          pageShop={pageShop}
          setShowShopPicker={setShowShopPicker}
          shopType="seller"
          canManageShop={isShopOwner(infoSource, [getOwner?._id, userID], myShop)}
        />
      )}
      {/* ── Vue boutique ─────────────────────────────────────────────── */}
      {pageShop === "boutique" && (
        <div style={infoSource.styleNav}>
          {myShop && shopInfo?._id && shopInfo?.type !== "provider" && (
            <ShopProductDisplaySettings
              shopId={shopInfo._id}
              stored={shopInfo.productDisplay}
              allowed={isSellerProductDisplayAllowed(infoSource?.allSettings)}
              currentDevice={displayDevice}
              previewDevice={displayPreviewDevice}
              onPreviewDeviceChange={setDisplayPreviewDevice}
              onDraftChange={setDisplayDraft}
              onSaved={(productDisplay) => { setDisplayDraft(null); setShopInfo((shop) => (shop ? { ...shop, productDisplay } : shop)); }}
            />
          )}
          {/* Si myShopDefault est défini → page personnalisée via PageRenderer */}
          {myShopDefault ? (
            selectedShopDoc ? (
              <PageRenderer
                doc={selectedShopDoc}
                pageData={previewDataByMode}
                infoSource={infoSource}
                token={token}
                device={pageRendererDevice}
                htmlSource={shopPageDoc?.htmlSource}
                htmlSourcePages={shopPageDoc?.htmlSourcePages}
              />
            ) : (
              <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"30vh", color:"#9b93b8", fontSize:"14px" }}>{elakayAutoText("h_ded223b60a95de", "Chargement de la page boutique…")}</div>
            )
          ) : (
            /* Sinon → vue produits par défaut */
            <>
              {shopLoadError && <div className="alert alert-danger" role="alert">{shopLoadError}</div>}
              <ShopHeroSlider hero={heroFromPub(getUserPub)} ownerId={getOwner?._id || getUserPub?._id || null}>
                <SliderPun135
                  SliderPunShow={false}
                  infoSource={infoSource}
                  getpub={getUserPub?.sliderShop}
                  text1={`Voici un guide complet et pratique.; pour toutes les variantes.; de ThreeDText`}
                  text2={shopDisplayName}
                  shop={true}
                />
              </ShopHeroSlider>
              <SwiperCategoriesMatrix
                shopId={shopInfo?._id || shopId}
                nbrArr={nbrArr}
                infoSource={infoSource}
                inView={true}
                loadProductsByArrival={loadProductsByArrival_}
                setSearch={setSearch}
                categoriesMatrix={getCategoriesUser}
                loading={firstShopLoad}
              />
              <SwiperPubCategoryProdMatrix
                shopId={shopInfo?._id || shopId}
                Follow={true}
                booFollow={booFollow}
                unFollow={unFollow}
                isFollowing={!unFollow}
                unFollowShop={unFollowShop}
                onFollowToggle={clickToFollowShop}
                findToFollowU={findToFollowU}
                setSearch={setSearch}
                inView={true}
                loadProductsByArrival={loadProductsByArrival_}
                ci={getCi}
                activeFollowBtn={siseProduct > 0}
                nbrArr={nbrArr}
                userID={userID}
                infoSource={infoSource}
                pubCategoryProdMatrix={pubCategoryProd}
                loading={firstShopLoad}
              />
              {/* gridAnimated/animateCards/resultAnimated left unset on purpose:
                  ProductGridShop already falls back to
                  infoSource.allSettings.productGrids.productGridShop when
                  these are undefined -- forcing them to false here used to
                  permanently override the admin's AnimationSettings. */}
              <ProductGridShop
                divCatProduct={divCatProduct}
                productsByArrival={productsByArrival}
                skip={skip}
                limit={limit}
                siseProduct={siseProduct}
                prodCat={prodCat}
                infoSource={infoSource}
                laguangeElakay={laguangeElakay}
                Card={Card}
                promoMaker={promoMaker}
                btnShopPromo={btnShopPromo}
                currentShopId={shopInfo?._id || shopId}
                loading={shopLoading}
                refShopName={refShopName}
                ButtonPagination={ButtonPagination}
                loadMore={loadMore}
                loadMore0={loadMore0}
                size={size}
                elakayEmptyBox={elakayEmptyBox}
                {...(productDisplayMode === "infinite"
                  ? { loadingMode: "infinite", onLoadMoreAsync: appendProducts, appending }
                  : {})}
              />
              {/* CTA pour le seller : créer/acheter une boutique */}
              {myShop && (
                <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:"12px", padding:"32px 20px", background:"#f9f6ff", borderTop:"1px solid #ede9fd", marginTop:"24px" }}>
                  <p style={{ margin:0, fontSize:"14px", fontWeight:600, color:"#6d28d9" }}>{elakayAutoText("h_457ade41e63791", "🏪 Personnalisez votre boutique avec le Page Builder")}</p>
                  <div style={{ display:"flex", gap:"10px", flexWrap:"wrap", justifyContent:"center" }}>
                    <button
                      onClick={() => setPageShop("builder")}
                      style={{ padding:"10px 22px", fontSize:"13px", fontWeight:700, color:"#fff", background:"linear-gradient(135deg,#6d28d9,#8b5cf6)", border:"none", borderRadius:"10px", cursor:"pointer" }}
                    >{elakayAutoText("h_ed938ff3de99e9", "🎨 Ouvrir le Builder")}</button>
                    <button
                      onClick={() => setShowShopPicker(true)}
                      style={{ padding:"10px 22px", fontSize:"13px", fontWeight:700, color:"#6d28d9", background:"#ede9fd", border:"1.5px solid #c4b5fd", borderRadius:"10px", cursor:"pointer" }}
                    >{elakayAutoText("h_449d130c916e1f", "🏪 Choisir une boutique")}</button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* ── Vue Builder / Preview (même cadre visuel que la boutique) ─── */}
      {myShop && pageShop !== "boutique" && (
        <div style={infoSource.styleNav}>
          <div style={{ width: "100%", maxWidth: "1500px", margin: "0 auto", padding: "12px 10px 20px", display: "flex", flexDirection: "column", gap: "12px" }}>

            {/* Barre de navigation entre les modes */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px 14px", background: "#fff", border: "1px solid #ece9f5", borderRadius: "14px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", flexWrap: "wrap", position: "sticky", top: "8px", zIndex: 3 }}>
              <button onClick={() => setPageShop("boutique")} style={modeBtn(pageShop === "boutique")}>{elakayAutoText("h_578206e6d61465", "🏪 Boutique")}</button>
              <span style={{ fontSize: "15px", fontWeight: 800, color: "#1a1a2e", marginRight: "auto", whiteSpace: "nowrap" }}>
                🏪 {shopDisplayName}
              </span>
              <button onClick={toggleBuilderPreview} style={modeBtn(pageShop === "preview" || pageShop === "builder")}>
                {pageShop === "preview" ? elakayAutoText("h_68241e4767639b", "✏️ Edit Builder") : elakayAutoText("h_618f9a03eab82b", "👁 Aperçu")}
              </button>

              {shopLiveDatasets?.store?.isLive && (
                <span style={{ fontSize: "11px", fontWeight: 700, color: "#059669", padding: "3px 10px", background: "#ecfdf5", borderRadius: "50px", border: "1px solid #a7f3d0" }}>{elakayAutoText("h_90b5e0cf3b9ba4", "● Données réelles ·")}{shopLiveDatasets.store.data.products.length}{elakayAutoText("h_c9be2316116c67", "produits")}</span>
              )}

              <button onClick={() => setPageShop("boutique")} style={{ padding: "8px 16px", fontSize: "13px", fontWeight: 600, color: "#ef4444", background: "#fff", border: "1px solid #fca5a5", borderRadius: "50px", cursor: "pointer" }}>{elakayAutoText("h_c1346c1267df43", "✕ Fermer")}</button>
            </div>

            {/* Zone de contenu */}
            <div style={{ width: "100%", border: "1px solid #ece9f5", borderRadius: "18px", overflow: "hidden", background: "#fff", boxShadow: "0 10px 30px rgba(60,30,110,0.08)" }}>

              {/* ── PageBuilder avec données live ── */}
              <div style={{ width: "100%", height: "auto", display: pageShop === "builder" ? "block" : "none" }}>
                  <React.Suspense fallback={<div role="status" style={{ padding: 32, textAlign: "center" }}>{elakayAutoText("h_loading_builder", "Loading Builder…")}</div>}><PageBuilder
                    liveDatasets={shopLiveDatasets}
                    onDocChange={(doc) => { builderDocRef.current = doc; }}
                    pageMode="store"
                    lockPageMode={true}
                    hideHeaderTemplateButton={true}
                    hideHeaderPreviewToggle={true}
                    hideLeftPreviewToggle={true}
                    fitParentHeight={false}
                    storeOnly={true}
                    infoSource={infoSource}
                    onSave={handleSavePage}
                    onLoadPage={handleLoadBuilderPage}
                    onDeletePage={handleDeleteSavedPage}
                    onFamilyUnlockPage={handleFamilyUnlockPage}
                    onPageMetaUpdated={(updated) => setSavedPageData((prev) => (prev && updated ? { ...prev, ...updated } : (updated || prev)))}
                    savedPageId={savedPageId}
                    savedPage={savedPageData}
                    currentUserId={isAuthenticated()?.user?._id || null}
                  /></React.Suspense>
              </div>

              {/* ── PageRenderer avec le doc courant ── */}
              {pageShop === "preview" && (
                builderDocRef.current ? (
                  <div style={{ background: "radial-gradient(circle at 50% 0%, #efeafa, #f6f4fb)", padding: "14px" }}>
                    <div style={{ width: "100%", background: "#fff", borderRadius: "14px", overflow: "hidden", boxShadow: "0 8px 24px rgba(60,30,110,0.10)" }}>
                      <PageRenderer
                        key={previewKey}
                        doc={builderDocRef.current}
                        pageData={previewDataByMode}
                        infoSource={infoSource}
                        token={token}
                        device={pageRendererDevice}
                        htmlSource={savedPageData?.htmlSource}
                        htmlSourcePages={savedPageData?.htmlSourcePages}
                      />
                    </div>
                  </div>
                ) : (
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "16px", color: "#9b93b8", padding: "60px 40px" }}>
                    <span style={{ fontSize: "56px" }}>🎨</span>
                    <p style={{ fontSize: "17px", fontWeight: 700, margin: 0, color: "#1a1a2e" }}>{elakayAutoText("h_8aab408e112fc9", "Aucune page construite")}</p>
                    <p style={{ fontSize: "14px", margin: 0, color: "#9b93b8", textAlign: "center", maxWidth: "360px" }}>{elakayAutoText("h_d4a3917500c3a2", "Ouvrez le Builder, choisissez un template et personnalisez votre boutique. Revenez ici pour prévisualiser le résultat.")}</p>
                    <button onClick={() => setPageShop("builder")} style={{ padding: "12px 28px", fontSize: "14px", fontWeight: 700, color: "#fff", background: "linear-gradient(135deg,#6d28d9,#8b5cf6)", border: "none", borderRadius: "50px", cursor: "pointer", boxShadow: "0 4px 16px rgba(109,40,217,0.25)" }}>{elakayAutoText("h_ed938ff3de99e9", "🎨 Ouvrir le Builder")}</button>
                  </div>
                )
              )}

              {/* ── Page d'aide Builder Help ── */}
              {pageShop === "helps" && (
                <React.Suspense fallback={<div role="status" style={{ padding: 32, textAlign: "center" }}>{elakayAutoText("h_loading_help", "Loading help…")}</div>}><PageBuilderHelp onClose={() => setPageShop("boutique")} mode="boutique" /></React.Suspense>
              )}

            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", padding: "10px 14px", background: "#fff", border: "1px solid #ece9f5", borderRadius: "14px", boxShadow: "0 2px 8px rgba(0,0,0,0.04)", flexWrap: "wrap", position: "sticky", bottom: "8px", zIndex: 3 }}>
              <button onClick={() => setPageShop("boutique")} style={modeBtn(pageShop === "boutique")}>{elakayAutoText("h_578206e6d61465", "🏪 Boutique")}</button>
              <button onClick={toggleBuilderPreview} style={modeBtn(pageShop === "preview" || pageShop === "builder")}>
                {pageShop === "preview" ? elakayAutoText("h_68241e4767639b", "✏️ Edit Builder") : elakayAutoText("h_618f9a03eab82b", "👁 Aperçu")}
              </button>
              <button onClick={() => setPageShop("helps")} style={modeBtn(pageShop === "helps")}>{elakayAutoText("h_b4b9fdaf93cfee", "❓ Builder Help")}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Drawer de sélection de boutique ──────────────────────────── */}
      {showShopPicker && myShop && createPortal(shopPickerMenu(), document.body)}
    </>
    );
};

export default ShopUserView;


  const PLACEHOLDER = {
    categoryID: null,
    name: null,          // <- on garde "name" pour matcher tes formats
    categoryIDList: null,    // <- optionnel
    products: null,  // <- champ corrigé
    autantique: false
  };
